module.exports = __webpack_public_path__ + "static/media/SF-Compact-Text-Light.0d718cf5.otf";